import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import BrandsPage from "./pages/BrandsPage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import KBeautyPage from "./pages/KBeautyPage";
import PriceListPage from "./pages/PriceListPage";
import TrindPage from "./pages/TrindPage";
import CityPage from "./pages/CityPage";
import CityHubPage from "./pages/CityHubPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import { WhatsAppButton } from "./components/WhatsAppButton";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    const id = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'smooth' }), 300);
    return () => clearTimeout(id);
  }, [pathname, hash]);

  return null;
};

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-white">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/brands" element={<BrandsPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/cosmetici-coreani" element={<KBeautyPage />} />
            <Route path="/richiesta-listino" element={<PriceListPage />} />
            <Route path="/rinforzante-unghie-trind" element={<TrindPage />} />
            <Route path="/distributore-k-beauty" element={<CityHubPage />} />
            <Route path="/distributore-k-beauty/:city" element={<CityPage />} />
            <Route path="/trind-farmacie" element={<Navigate to="/rinforzante-unghie-trind" replace />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
